exports.getWithTimestamps = function (obj, username, timestamp) {
  return Object.assign({}, obj, {
    createdAt: obj.createdAt || timestamp,
    createdBy: obj.createdBy || username,
    updatedAt: timestamp,
    updatedBy: username
  })
}
